import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33b6be2e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/usercenter.less?vue&type=style&index=0&id=33b6be2e&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=33b6be2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6be2e",
  null
  
)

export default component.exports